/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/cloud-backup-plans/actions';
import { getAllCloudBackupPlans, requestingCloudBackupPlans } from 'state/cloud-backup-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentCloudBackupId, getCurrentCloudBackupPlanId, getCurrentCloudBackup } from 'state/current-cloud-backup/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentCloudBackup } from 'state/current-cloud-backup/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectCloudBackupPlan = (props) => {
    const cloudBackupPlans = props.cloudBackupPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});

    // const onChange = (value) => {
    //     if (!props.cloudBackupSubscriptionId) {
    //         return newPlanSubscription(value);
    //     }

    //     let plan = find(cloudBackupPlans, { id: value });
    //     let addon = resolveLicenseAddon(plan);
    // };

    const onChange = (value) => {
        //if (!props.cloudBackupSubscriptionId) {
            return newPlanSubscription(value);
        //}

        let plan = find(cloudBackupPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Subscribe to Cloud Backup',
            message: 'Select a Cloud Backup plan.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentCloudBackup={props.currentCloudBackup}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubscribe(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestCloudBackupPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubscribe = (value) => {
        setSubmitting(true);
        console.log(value);
        console.log(get(values));
        return props
            .swapSubscription(props.cloudBackupSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Cloud Backup subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.cloudBackupSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Cloud Backup subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            close: () => {},
            success: () => {
                props.requestCurrentCloudBackup();
                props.successNotice('Your Cloud Backup subscription has been created.');
                page.redirect('/dashboard/cloud-backup');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {cloudBackupPlans.map((plan, i) => {
                        return (
                                <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentCloudBackup && props.currentCloudBackup.status == 'cancelled')
                                        ? plan.id == props.cloudBackupPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        cloudBackupPlans: getAllCloudBackupPlans(state),
        addons: getAllAddons(state),
        cloudBackupSubscriptionId: getCurrentCloudBackupId(state),
        cloudBackupPlanId: getCurrentCloudBackupPlanId(state),
        currentCloudBackup: getCurrentCloudBackup(state),
        currentUser: getCurrentUser(state),
        requesting: requestingCloudBackupPlans(state),
    }),
    {
        requestCloudBackupPlans: requestPlansIfNotRequested,
        requestCurrentCloudBackup,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectCloudBackupPlan);
